module.exports = __webpack_public_path__ + "images/banners/pages_iphone/iphone-page-mock_half_2dbd661e3eed2b14778ddde6f342a426.png";